import { css, Global } from "@emotion/react"
import "@fontsource/montserrat"
import "@fontsource/montserrat/500.css"
import "@fontsource/montserrat/700.css"
import React from "react"

export const theme = {
  black: "#000000",
  dark: "#232323",
  darkGrey: "#464646",
  grey: "#666666",
  lightGrey: "#999999",
  light: "#FAF9F9",
  white: "#FFFFFF",
  blue: "#009dd8",
  darkBlue: "#02609b",
  pink: "#EC328F",
}

export default function GlobalStyles({ mobileNav }) {
  return (
    <Global
      styles={theme => css`
        html {
          box-sizing: border-box;
          overflow-y: ${mobileNav ? "hidden" : "auto"};
          font: 100%/1.62em "Montserrat", sans-serif;
          font-size: 100%;
          overflow-x: hidden;
          -ms-text-size-adjust: 100%;
          -webkit-text-size-adjust: 100%;
          scroll-behavior: smooth;
        }

        a {
          color: black;
          cursor: pointer;
        }
        body {
          color: ${theme.black};
          font-family: "Montserrat", sans-serif;
          font-weight: normal;
          font-size: 1rem;
          line-height: 1.62em;
          word-wrap: break-word;
          font-kerning: normal;
          overflow-x: hidden;
          word-wrap: break-word;
          margin: 0;
          -webkit-font-smoothing: antialiased;
        }

        h1 {
          font-size: 4.25rem;
          color: ${theme.blue};
          line-height: 1.62em;
        }

        h2 {
          font-size: 2.625rem;
          color: ${theme.blue};
          line-height: 1.62em;
        }

        h3 {
          font-size: 1.625rem;
          line-height: 1.62em;
        }

        h4 {
          font-size: 1.25rem;
          line-height: 1.62rem;
        }

        h5 {
          font-size: 1.125rem;
          line-height: 1.44em;
        }
        label {
          color: ${theme.dark};
          font-weight: 700;
          line-height: 1.62em;
        }

        input,
        textarea,
        textarea::placeholder,
        input::placeholder {
          color: ${theme.lightGrey};
          line-height: 1.62em;
        }

        a {
          text-decoration: none;
          line-height: 1.62em;
        }

        *,
        *:before,
        *:after {
          box-sizing: border-box;
          font-family: "Montserrat", sans-serif;
        }

        img {
          max-width: 100%;
          display: block;
        }

        button,
        input,
        optgroup,
        select,
        textarea {
          margin: 0;
        }

        button,
        input {
          overflow: visible;
        }

        ::-webkit-file-upload-button {
          -webkit-appearance: button;
          font: inherit;
        }

        .container {
          max-width: 1100px;
          margin-left: auto;
          margin-right: auto;
          padding-right: 16px;
          padding-left: 16px;
        }

        @media (min-width: 1150px) {
          .container {
            padding: 0;
          }
        }
      `}
    />
  )
}
